import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 15000,
});

export const apiClient = client;

export const fetchDates = async (params = {}) => {
  const cleaned = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== "" && v !== null)
  );
  const { data } = await client.get("/dates", { params: cleaned });
  return data;
};

export const fetchFeatured = async () => {
  const { data } = await client.get("/dates/featured");
  return data;
};

export const fetchDate = async (id) => {
  const { data } = await client.get(`/dates/${id}`);
  return data;
};

export const fetchRelated = async (id, limit = 6) => {
  const { data } = await client.get(`/dates/${id}/related`, { params: { limit } });
  return data;
};

export const fetchCategories = async () => {
  const { data } = await client.get("/categories");
  return data;
};

export const fetchStatuses = async () => {
  const { data } = await client.get("/recognition-statuses");
  return data;
};

export const fetchStats = async () => {
  const { data } = await client.get("/stats");
  return data;
};

export const submitProposal = async (payload) => {
  const { data } = await client.post("/submissions", payload);
  return data;
};

export const fetchDonationConfig = async () => {
  const { data } = await client.get("/donations/config");
  return data;
};

export const createDonationCheckout = async (payload) => {
  const { data } = await client.post("/donations/checkout", payload);
  return data;
};

export const fetchDonationStatus = async (sessionId) => {
  const { data } = await client.get(`/donations/status/${sessionId}`);
  return data;
};

export const fetchSupporters = async () => {
  const { data } = await client.get("/supporters");
  return data;
};
